import axios from 'axios';
import { BASE_URL } from '../../api/inquiries';

const API_BASE = `${BASE_URL}/api/estimate`;

// Helper to handle auth headers if needed (though existing axios usage didn't seem to force it?)
// If we need auth, we should attach token.
// For now, let's use simple axios as requested by the error.

export const getActiveQuestionnaires = async () => {
    try {
        const res = await axios.get(`${API_BASE}/questionnaire/active`);
        return res.data;
    } catch (error) {
        console.error('API Error: getActiveQuestionnaires', error);
        throw error;
    }
};

export const getLatestQuestionnaire = async () => {
    try {
        const res = await axios.get(`${API_BASE}/questionnaire/latest`);
        return res.data;
    } catch (error) {
        console.error('API Error: getLatestQuestionnaire', error);
        throw error;
    }
};

export const startSession = async (versionId) => {
    try {
        const res = await axios.post(`${API_BASE}/sessions`, { versionId });
        return res.data;
    } catch (error) {
        console.error('API Error: startSession', error);
        throw error;
    }
};

export const getSession = async (sessionKey) => {
    try {
        const res = await axios.get(`${API_BASE}/sessions/key/${sessionKey}`);
        return res.data;
    } catch (error) {
        console.error('API Error: getSession', error);
        throw error;
    }
};

export const submitAnswer = async (sessionKey, answerData) => {
    try {
        const res = await axios.post(`${API_BASE}/sessions/key/${sessionKey}/answers`, answerData);
        return res.data;
    } catch (error) {
        console.error('API Error: submitAnswer', error);
        throw error;
    }
};

export const goBack = async (sessionKey) => {
    try {
        const res = await axios.post(`${API_BASE}/sessions/key/${sessionKey}/back`);
        return res.data;
    } catch (error) {
        console.error('API Error: goBack', error);
        throw error;
    }
};

export const sendEstimateEmail = async (sessionKey, customerData) => {
    try {
        // customerData: { email, companyName, contactPerson, phone, inquiry, wantConsulting }
        const res = await axios.post(`${API_BASE}/sessions/key/${sessionKey}/email`, customerData);
        return res.data;
    } catch (error) {
        console.error('API Error: sendEstimateEmail', error);
        throw error;
    }
};

export const linkInquiry = async (sessionKey, contactInquiryId) => {
    try {
        const res = await axios.post(`${API_BASE}/sessions/key/${sessionKey}/link-inquiry`, { contactInquiryId });
        return res.data;
    } catch (error) {
        console.error('API Error: linkInquiry', error);
        throw error;
    }
};
